import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";

import { styled } from "@mui/material/styles";

import TableApproveList from "./tableApproveList";
import { classifyRequestTimeStatus, isStatusEnabled } from "./historyStatusFilter";

const StyledWrapHistory = styled("div")({
  marginTop: 16,
});

function TableTimeApproval(props) {
  const { searchName, menu, filterStatus } = props;
  const { result: requestTimeList } = useSelector((state) => state.requestTime);
  const [approvalSelected, setApprovalSelected] = useState([]);

  const renderRequestTime = () => {
    const result = [];

    requestTimeList
      .filter((x) => x.idRequestType === menu)
      .forEach((element) => {
        const status = classifyRequestTimeStatus(element);
        if (!status) {
          return;
        }
        if (status === "approved") {
          element.isApprove = 1;
        } else if (status === "notApproved") {
          element.isApprove = 0;
        }
        if (isStatusEnabled(status, filterStatus)) {
          result.push(element);
        }
      });

    result.sort(function (a, b) {
      return new Date(b.createDate) - new Date(a.createDate);
    });

    return result;
  };

  return (
    <Box style={{ marginTop: 4 }}>
      <StyledWrapHistory>
        <div>
          <TableApproveList
            checkbox={false}
            dataTable={
              requestTimeList
                ? renderRequestTime()
                : []
            }
            approvalSelected={approvalSelected}
            setApprovalSelected={setApprovalSelected}
            searchName={searchName}
          />
        </div>
      </StyledWrapHistory>
    </Box>
  );
}

export default TableTimeApproval;
